import { GENERATE_SIGNED_UP_CREATORS_REPORT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'

export default {
	[GENERATE_SIGNED_UP_CREATORS_REPORT]: {
		endpointType: otherEndpointType,
	},
}
